import { render, staticRenderFns } from "./UnderUserTable.vue?vue&type=template&id=ec51eb96&scoped=true&"
import script from "./UnderUserTable.vue?vue&type=script&lang=js&"
export * from "./UnderUserTable.vue?vue&type=script&lang=js&"
import style0 from "./UnderUserTable.vue?vue&type=style&index=0&id=ec51eb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec51eb96",
  null
  
)

export default component.exports